import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkConfig } from 'app/providers/StoreProvider';
import { CatalogItemInOrder } from 'entities/CatalogItem/model/types/CatalogItemSchema';

import { EditItemsInOrderRequestParams } from '../../types/editItemsInOrderSchema';

export const editOrderItem = createAsyncThunk<
    CatalogItemInOrder,
    EditItemsInOrderRequestParams,
    ThunkConfig<string>
>(
    'order/editOrderItem',
    async ({ orderId, itemId, qty, requestData }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        const dataToSend: any = {
            qty,
        };

        if (requestData) {
            dataToSend.qty = requestData.quantity;
            dataToSend.selectedProposals = requestData.selectedProposals;
        }

        try {
            const response = await extra.api.patch<CatalogItemInOrder>(
                `/v1/orders/${orderId}/items/${itemId}`,
                dataToSend,
            );

            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
